// Чип статуса загрузки. Общий для «Моих загрузок» и экрана анализа — иначе один
// и тот же статус называется на двух экранах по-разному.

import { AlertCircle, Check, Clock, Loader2 } from 'lucide-react';
import { FAILURE_HINT, type StatusTone } from '@/lib/uploadDisplay';
import type { UploadFailureReason } from '@/api/types';

export function UploadStatusChip({
  tone,
  text,
  failure,
}: {
  tone: StatusTone;
  text: string;
  failure: UploadFailureReason | null;
}) {
  // OK — крупная зелёная пилюля (прототип s9). Остальные тоны — компактный chip.
  if (tone === 'ok') {
    return (
      <span className="inline-flex flex-shrink-0 items-center gap-1 rounded bg-green-50 px-1.5 py-1 text-hl-small font-bold text-green-700">
        <Check className="h-3 w-3" strokeWidth={3} />
        {text}
      </span>
    );
  }

  // hold — «ждём нас» (reported): нейтральный слейт + часы, без крутилки (ничего
  // не выполняется прямо сейчас) и без красного (это не ошибка человека).
  const toneClass = {
    warn: 'bg-amber-50 text-amber-700',
    wait: 'bg-slate-100 text-slate-600',
    hold: 'bg-slate-100 text-slate-600',
    err: 'bg-rose-50 text-rose-700',
  }[tone];
  const ToneIcon = { warn: Clock, wait: Loader2, hold: Clock, err: AlertCircle }[tone];
  const title = failure ? FAILURE_HINT[failure] : undefined;

  return (
    <span
      title={title}
      className={`inline-flex flex-shrink-0 items-center gap-1 rounded-full px-2 py-1 text-xs font-medium ${toneClass}`}
    >
      <ToneIcon className="h-3 w-3" />
      {text}
    </span>
  );
}

export function FileTypeBadge({ mimeType }: { mimeType: string }) {
  const isPdf = mimeType === 'application/pdf';
  const label = isPdf ? 'PDF' : 'JPG';
  // PDF→blue, image→amber (палитра из прототипа s9).
  const palette = isPdf ? 'bg-blue-100 text-blue-700' : 'bg-amber-100 text-amber-700';

  return (
    <div className={`flex h-12 w-10 flex-shrink-0 items-center justify-center rounded-md ${palette}`}>
      <span className="text-hl-small font-bold">{label}</span>
    </div>
  );
}
